export default __webpack_public_path__ + "static/media/80.9efdb78c.jpg";